/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { useAppSelector } from '../../../reducers';
import { getCurrentUser } from '../../../selectors/user';
import './BulkActionToolbar.scss';
import { FloatingToolbar } from '@g17eco/molecules/floating-toolbar';
import { useChatbotVisibilityControl } from '@hooks/useChatbotVisibilityControl';
import { BulkActionUtr } from '@g17eco/types/survey-question-list';

export interface ActionsToolbarProps {
  selectedQuestions: BulkActionUtr[];
  toggleSelectAll: () => void;
  handleClose: () => void;
  questionCount: number;
  buttons: {
    name: string;
    Component: React.ElementType;
    buttonProps: object;
  }[];
}

export const ActionsToolbar = (props: ActionsToolbarProps) => {
  const {
    selectedQuestions,
    handleClose,
    buttons = [],
  } = props;

  const currentUser = useAppSelector(getCurrentUser);
  const selectedUniqueCount = new Set(selectedQuestions.map((q) => q._id)).size;

  useChatbotVisibilityControl({ isHidden: selectedUniqueCount > 0 });

  if (!currentUser || buttons.length === 0) {
    return null;
  }

  const renderedButtons = buttons.map(({ name, Component, buttonProps }) => <Component key={name} {...buttonProps} />);

  const selectedCountLabel = (
    <span className='p-1 text-colorThemeTextMedium d-inline-block' style={{ minWidth: '80px' }}>
      {selectedUniqueCount} selected
    </span>
  );

  return (
    <FloatingToolbar handleClose={handleClose} items={[...renderedButtons, selectedCountLabel]} isOpen={selectedUniqueCount > 0} />
  );
};
